// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchDropdown_wrapper___Z_9X","main":"SearchDropdown_main__QUr1B","active":"SearchDropdown_active__y_Ao3","search-fade-in":"SearchDropdown_search-fade-in__PQeZV"};